<template>
    <tr v-if="!isMobile">
        <!-- Admission Date -->
        <td class="text-center ">
            {{ formatDate(tableItems.ADMI_D) ? formatDate(tableItems.ADMI_D) : "-" }}
        </td>
        <!-- Release Date -->
        <td class="text-center">
            {{ formatDate(tableItems.RELE_D) ? formatDate(tableItems.RELE_D) : "-" }}
        </td>

        <!-- Availment Type -->
        <td class="text-center ">
            {{ tableItems.ADMI_D == null ? "Out-Patient" : "In-Patient" }}
        </td>

        <!-- Hospital's Name -->
        <td class="text-center">
            {{ tableItems.HOSP ? tableItems.HOSP : "-" }}
        </td>

        <!-- Doctor's Name -->
        <td class="text-center">
            {{ tableItems.DOC ? tableItems.DOC : "-" }}
        </td>

        <!-- Hospital Bill -->
        <td class="text-center">
            {{ tableItems.BILL_T == "H" ? tableItems.ACTU_A : "-" }}
        </td>

        <!-- Prof Fee -->
        <td class="text-center">
            {{ tableItems.BILL_T == "P" ? tableItems.ACTU_A : "-" }}
        </td>

        <!-- Diagnosis -->
        <td class="text-center">
            {{ tableItems.DIAG ? tableItems.DIAG : "-" }}
        </td>

    <!-- Procedure -->
    <!--
    <td class="text-center">
      {{ tableItems.ACTI ? tableItems.ACTI : "-" }}
    </td>
    -->
    </tr>
</template>

<script>
import { moment } from '../../../utils/date-shim'
export default {
    props: ['isMobile', 'tableItems'],

    methods: {
        formatDate(date) {
            if (date == null) {
                return '-'
            } else {
                return moment(date).utcOffset('+0800').format('MM/DD/YY')
            }
        }
    }
}
</script>

<style></style>
